 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLHALFTITLE from '@/components/xhtml/halftitle'
 import XHTMLSERIESPAGE from '@/components/xhtml/seriespage'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLNOTETOREADER from '@/components/xhtml/notetoreader'
 import XHTMLINTRODUCTION from '@/components/xhtml/introduction'
 import XHTMLCHAPTER1 from '@/components/xhtml/chapter1'
 import XHTMLCHAPTER2 from '@/components/xhtml/chapter2'
 import XHTMLCHAPTER3 from '@/components/xhtml/chapter3'
 import XHTMLCHAPTER4 from '@/components/xhtml/chapter4'
 import XHTMLCHAPTER5 from '@/components/xhtml/chapter5'
 import XHTMLCHAPTER6 from '@/components/xhtml/chapter6'
 import XHTMLCHAPTER7 from '@/components/xhtml/chapter7'
 import XHTMLCONCLUSION from '@/components/xhtml/conclusion'
 import XHTMLACKNOWLEDGMENTS from '@/components/xhtml/acknowledgments'
 import XHTMLDISCUSSION from '@/components/xhtml/discussion'
 import XHTMLFURTHERREADING from '@/components/xhtml/furtherreading'
 import XHTMLNOTES from '@/components/xhtml/notes'
 import XHTMLWORKCITED from '@/components/xhtml/workcited'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLABOUTTHEAUTHOR from '@/components/xhtml/abouttheauthor'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/notetoreader",
 			"name" : "xhtml/notetoreader",
 			"component" : XHTMLNOTETOREADER
 		},
 		{
 			"path" : "/xhtml/introduction",
 			"name" : "xhtml/introduction",
 			"component" : XHTMLINTRODUCTION
 		},
 		{
 			"path" : "/xhtml/chapter1",
 			"name" : "xhtml/chapter1",
 			"component" : XHTMLCHAPTER1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js